import React, { useEffect } from 'react'

export const Dashboard = () => {
  useEffect(() => {
    // Set the body overflow to hidden when the component mounts
    document.body.style.overflow = 'hidden'

    // Reset the body overflow when the component unmounts
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <div
      style={{
        top: -24,
        left: -24,
        width: 'calc(100% + 48px)',
        height: 'calc(100vh - 64px)',
        position: 'relative',
        backgroundColor: '#333',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <iframe
        title='Looker Studio Dashboard'
        width='100%'
        height='100%'
        src='https://lookerstudio.google.com/embed/reporting/9222cf03-a51b-4c5d-b493-50f7d91cf320/page/p_to1awvbx1d'
        frameBorder='0'
        style={{ border: 0, maxWidth: '1500px' }}
        allowFullScreen
        sandbox='allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'></iframe>
    </div>
  )
}
